// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YMrsS","footer":"styles_footer__3yRU3","passCodeTooltip":"styles_passCodeTooltip__2XnBV"};